//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
export default {
  name: 'Maintenance',
  computed: {
    maintenanceEnd: function maintenanceEnd() {
      return moment.utc(this.$store.state.app.maintenanceEnd).local().format('YYYY-MM-DD HH:mm UTCZ');
    }
  }
};